import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, theme } from "../theme";
export const ProgressBar = ({ progress, width = 65, height = 10, progressColor = progressColorMap, testId, children, }) => (_jsxs(Meter, { width: width, height: height, children: [children, _jsx("div", { style: {
                width: `${progress}%`,
                height,
                backgroundColor: progressColor(progress),
            }, "data-test-id": testId })] }));
function progressColorMap(progress) {
    if (progress < 25)
        return theme.color.orange100;
    else if (progress < 75)
        return theme.color.yellow100;
    else
        return theme.color.green100;
}
const Meter = styled.div `
  position: relative;
  display: flex;
  flex-direction: row;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  background: rgba(168, 182, 202, 0.23);
`;
